import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showModal: false,
  currentIndex: -1,
  checkout: {
    checkTime: "",
    checkDate: "",
    id: -1,
  },
  refetch: false,
  quickAnswer: [],
};

const incidenciaSlice = createSlice({
  name: "incidencia",
  initialState,
  reducers: {
    setShowModal: (state, action) => {
      state.showModal = action.payload;
    },
    setCurrentIndex: (state, action) => {
      state.currentIndex = action.payload;
    },
    setRefetch: (state, action) => {
      state.refetch = action.payload;
    },
    setQuickAnswer: (state, action) => {
      state.quickAnswer = action.payload;
    },
  },
});

export const { setShowModal, setCurrentIndex, setRefetch, setQuickAnswer } =
  incidenciaSlice.actions;
export default incidenciaSlice.reducer;
